var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "tab-content" },
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c("table", { staticClass: "table table-bordered" }, [
                      _c("thead", [
                        _c("tr", [
                          _c(
                            "th",
                            { staticClass: "title", attrs: { colspan: "4" } },
                            [_vm._v("面談紀錄")]
                          ),
                        ]),
                      ]),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "width-15 text-right" }, [
                            _vm._v("姓名"),
                          ]),
                          _c(
                            "td",
                            { staticClass: "width-35" },
                            [
                              _vm._v(" " + _vm._s(_vm.interviewee.Name) + " "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ml-2",
                                  attrs: { size: "mini" },
                                  on: { click: _vm.viewResume },
                                },
                                [_vm._v(" 檢視履歷 ")]
                              ),
                            ],
                            1
                          ),
                          _c("td", { staticClass: "width-15 text-right" }, [
                            _vm._v("性別"),
                          ]),
                          _c("td", { staticClass: "width-35" }, [
                            _vm._v(_vm._s(_vm.interviewee.Sex)),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "width-15 text-right" }, [
                            _vm._v("應徵職務"),
                          ]),
                          _c("td", { staticClass: "width-35" }, [
                            _vm._v(
                              " " + _vm._s(_vm.interviewee.Position) + " "
                            ),
                          ]),
                          _c("td", { staticClass: "width-15 text-right" }, [
                            _vm._v("職等"),
                          ]),
                          _c(
                            "td",
                            { staticClass: "width-35" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-100",
                                  attrs: {
                                    disabled:
                                      _vm.interviewee.ResumeType === "DL",
                                    placeholder: "請選擇",
                                  },
                                  model: {
                                    value: _vm.form.ExpectedJobLevel,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "ExpectedJobLevel",
                                        $$v
                                      )
                                    },
                                    expression: "form.ExpectedJobLevel",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "3", value: "3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "4", value: "4" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "5", value: "5" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "6", value: "6" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "6.3", value: "6.3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "7", value: "7" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "7.3", value: "7.3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "8", value: "8" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "8.3", value: "8.3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "9", value: "9" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "9.3", value: "9.3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "10", value: "10" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "10.3", value: "10.3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "10.5", value: "10.5" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "10.7", value: "10.7" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "11", value: "11" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "11.3", value: "11.3" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "11.5", value: "11.5" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "12", value: "12" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "13", value: "13" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "13.3", value: "13.3" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v("測驗成績"),
                          ]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c(
                              "table",
                              { staticClass: "table table-bordered" },
                              [
                                _c("thead", [
                                  _c(
                                    "tr",
                                    { staticClass: "text-center" },
                                    _vm._l(_vm.form.Scores, function (item) {
                                      return _c("th", { key: item.Name }, [
                                        _vm._v(" " + _vm._s(item.Name) + " "),
                                      ])
                                    }),
                                    0
                                  ),
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.form.Scores, function (item) {
                                    return _c(
                                      "td",
                                      {
                                        key: item.Name,
                                        staticClass: "text-center",
                                      },
                                      [_vm._v(" " + _vm._s(item.Score) + " ")]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _vm._v(" 面談評估 "),
                          ]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c(
                              "table",
                              { staticClass: "table table-bordered" },
                              [
                                _c("tr", [
                                  _c("th"),
                                  _c("th", { staticClass: "text-center" }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("th", { staticClass: "text-center" }, [
                                    _vm._v("否"),
                                  ]),
                                ]),
                                _vm._l(
                                  _vm.form.InterviewRecordAppraisals,
                                  function (item) {
                                    return [
                                      _c("tr", { key: item.Name }, [
                                        _c("td", [_vm._v(_vm._s(item.Name))]),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                item.Result,
                                                              expression:
                                                                "item.Result",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                          },
                                                          domProps: {
                                                            value: true,
                                                            checked: _vm._q(
                                                              item.Result,
                                                              true
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                item,
                                                                "Result",
                                                                true
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                item.Result,
                                                              expression:
                                                                "item.Result",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                          },
                                                          domProps: {
                                                            value: false,
                                                            checked: _vm._q(
                                                              item.Result,
                                                              false
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                item,
                                                                "Result",
                                                                false
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      item.Result === false
                                        ? _c("tr", { key: item.Id }, [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "4" } },
                                              [
                                                _c("ValidationProvider", {
                                                  attrs: { rules: "required" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c("el-input", {
                                                              staticClass:
                                                                "w-100",
                                                              attrs: {
                                                                type: "textarea",
                                                                rows: 2,
                                                                maxlength: "50",
                                                                "show-word-limit":
                                                                  "",
                                                                placeholder:
                                                                  "備註",
                                                              },
                                                              model: {
                                                                value:
                                                                  item.Remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "Remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.Remark",
                                                              },
                                                            }),
                                                            errors[0]
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          errors[0]
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _vm.interviewee.ResumeType === "IDL"
                          ? _c("tr", [
                              _c("td", { staticClass: "text-right" }, [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("所負義務"),
                                _c("br"),
                                _vm._v("既有智財評估 "),
                              ]),
                              _c("td", { attrs: { colspan: "3" } }, [
                                _vm._v(
                                  " 本應徵者在履歷表上有聲明其所負義務/既有智財，謹此提供其聲明內容，供主管了解並作為是否任用之評估。 "
                                ),
                                _c(
                                  "div",
                                  [
                                    _vm._v(" 說明： "),
                                    _c("br"),
                                    _vm._v(
                                      " 1. 為強化智財風險管控，公司招募流程會請應徵者聲明其所負義務/既有智財，以了解應徵者是否對前雇主負有競業禁止或保密義務，及其曾取得或申請中的智財。 "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " 2. 由於應徵者的既有智財可能屬於其前雇主的資產，應徵者應遵守其與前雇主的保密義務。聘用應徵者之後，公司亦須注意監督，防止人員有侵害他人智財的行為。 "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " 3. 如對於是否任用的風險評估有疑問，敬請聯繫人資安排與法務進一步諮詢。 "
                                    ),
                                    _c("br"),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: {
                                          required: { allowFalse: false },
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                    },
                                                  },
                                                  [
                                                    _c("label", [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.riskControlCheck,
                                                            expression:
                                                              "riskControlCheck",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "checkbox",
                                                          id: "checkRiskControl",
                                                          name: "checkRiskControl",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              _vm.riskControlCheck
                                                            )
                                                              ? _vm._i(
                                                                  _vm.riskControlCheck,
                                                                  null
                                                                ) > -1
                                                              : _vm.riskControlCheck,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.riskControlCheck,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.riskControlCheck =
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ]))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.riskControlCheck =
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                              }
                                                            } else {
                                                              _vm.riskControlCheck =
                                                                $$c
                                                            }
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for: "checkRiskControl",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 已考量並完成風險評估 "
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    errors[0]
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                            staticStyle: {
                                                              "margin-left":
                                                                "20px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " 請進行面談評估 "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _vm._v("面談說明"),
                          ]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("el-input", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "textarea",
                                                rows: 6,
                                                maxlength: "400",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: _vm.form.Remark,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "Remark",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.Remark",
                                              },
                                            }),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _vm._v("面談結果"),
                          ]),
                          _c(
                            "td",
                            { attrs: { colspan: "3" } },
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "required", name: "面談結果" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form
                                                            .InterviewResult,
                                                        expression:
                                                          "form.InterviewResult",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "錄取",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.form
                                                          .InterviewResult,
                                                        "錄取"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.form,
                                                          "InterviewResult",
                                                          "錄取"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for: "InterviewResult0",
                                                      },
                                                    },
                                                    [_vm._v(" 錄取 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form
                                                            .InterviewResult,
                                                        expression:
                                                          "form.InterviewResult",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "考慮中",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.form
                                                          .InterviewResult,
                                                        "考慮中"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.form,
                                                          "InterviewResult",
                                                          "考慮中"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for: "InterviewResult0",
                                                      },
                                                    },
                                                    [_vm._v(" 考慮中 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form
                                                            .InterviewResult,
                                                        expression:
                                                          "form.InterviewResult",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "複試",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.form
                                                          .InterviewResult,
                                                        "複試"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.form,
                                                          "InterviewResult",
                                                          "複試"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for: "InterviewResult0",
                                                      },
                                                    },
                                                    [_vm._v(" 複試 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form
                                                            .InterviewResult,
                                                        expression:
                                                          "form.InterviewResult",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      value: "不錄取",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.form
                                                          .InterviewResult,
                                                        "不錄取"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.form,
                                                          "InterviewResult",
                                                          "不錄取"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for: "InterviewResult0",
                                                      },
                                                    },
                                                    [_vm._v(" 不錄取 ")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v("個人備註"),
                          ]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("el-input", {
                                  staticClass: "w-100",
                                  attrs: {
                                    type: "textarea",
                                    rows: 6,
                                    maxlength: "800",
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value: _vm.form.PersonalRemark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "PersonalRemark", $$v)
                                    },
                                    expression: "form.PersonalRemark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "12" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: { type: "button" },
                                  on: { click: _vm.goBack },
                                },
                                [_vm._v(" 返回 ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(
                                        _vm.saveInterviewRecord
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 儲存 ")]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "modal fade bd-example-modal-lg",
          attrs: { id: "resumeModal", tabindex: "-1", "data-focus": "false" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c(
              "div",
              { staticClass: "modal-content progress-resume-modal" },
              [
                _c("div", { staticClass: "modal-header" }, [_vm._v("履歷")]),
                _c(
                  "perfect-scrollbar",
                  { staticClass: "modal-body" },
                  [
                    _vm.ResumeType === "DL"
                      ? _c("DlResume", { attrs: { ResumeId: _vm.ResumeId } })
                      : _vm._e(),
                    _vm.ResumeType === "IDL"
                      ? _c("IdlResume", { attrs: { ResumeId: _vm.ResumeId } })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-footer" }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }